<template>
    <div class="left">
        <div class="map">
            <ECharts :options="options"  />
        </div>
    </div>
</template>

<script>
    /**
     * 省份简称全称映射表
     * @type {*[]}
     */
    const provinceArray = [
        {
            name: '安徽',
            fullName: '安徽省'
        },
        {
            name: '澳门',
            fullName: '澳门特别行政区'
        },
        {
            name: '北京',
            fullName: '北京市'
        },
        {
            name: '重庆',
            fullName: '重庆市'
        },
        {
            name: '福建',
            fullName: '福建省'
        },
        {
            name: '甘肃',
            fullName: '甘肃省'
        },
        {
            name: '广东',
            fullName: '广东省'
        },
        {
            name: '广西',
            fullName: '广西壮族自治区'
        },
        {
            name: '贵州',
            fullName: '贵州省'
        },
        {
            name: '海南',
            fullName: '海南省'
        },
        {
            name: '河北',
            fullName: '河北省'
        },
        {
            name: '黑龙江',
            fullName: '黑龙江省'
        },
        {
            name: '河南',
            fullName: '河南省'
        },
        {
            name: '湖北',
            fullName: '湖北省'
        },
        {
            name: '湖南',
            fullName: '湖南省'
        },
        {
            name: '江苏',
            fullName: '江苏省'
        },
        {
            name: '江西',
            fullName: '江西省'
        },
        {
            name: '吉林',
            fullName: '吉林省'
        },
        {
            name: '辽宁',
            fullName: '辽宁省'
        },
        {
            name: '内蒙古',
            fullName: '内蒙古自治区'
        },
        {
            name: '宁夏',
            fullName: '宁夏回族自治区'
        },
        {
            name: '青海',
            fullName: '青海省'
        },
        {
            name: '山东',
            fullName: '山东省'
        },
        {
            name: '上海',
            fullName: '上海市'
        },
        {
            name: '山西',
            fullName: '山西省'
        },
        {
            name: '陕西',
            fullName: '陕西省'
        },
        {
            name: '四川',
            fullName: '四川省'
        },
        {
            name: '台湾',
            fullName: '台湾省'
        },
        {
            name: '天津',
            fullName: '天津市'
        },
        {
            name: '香港',
            fullName: '香港特别行政区'
        },
        {
            name: '新疆',
            fullName: '新疆维吾尔自治区'
        },
        {
            name: '西藏',
            fullName: '西藏自治区'
        },
        {
            name: '云南',
            fullName: '云南省'
        },
        {
            name: '浙江',
            fullName: '浙江省'
        }
    ]
    import ECharts from 'vue-echarts'
    import echarts from 'echarts/lib/echarts'
    import 'echarts/lib/chart/scatter'
    import 'echarts/map/js/china'
    import 'echarts/map/js/province/anhui'
    import 'echarts/map/js/province/aomen'
    import 'echarts/map/js/province/beijing'
    import 'echarts/map/js/province/chongqing'
    import 'echarts/map/js/province/fujian'
    import 'echarts/map/js/province/gansu'
    import 'echarts/map/js/province/guangdong'
    import 'echarts/map/js/province/guangxi'
    import 'echarts/map/js/province/guizhou'
    import 'echarts/map/js/province/hainan'
    import 'echarts/map/js/province/hebei'
    import 'echarts/map/js/province/heilongjiang'
    import 'echarts/map/js/province/henan'
    import 'echarts/map/js/province/hubei'
    import 'echarts/map/js/province/hunan'
    import 'echarts/map/js/province/jiangsu'
    import 'echarts/map/js/province/jiangxi'
    import 'echarts/map/js/province/jilin'
    import 'echarts/map/js/province/liaoning'
    import 'echarts/map/js/province/neimenggu'
    import 'echarts/map/js/province/ningxia'
    import 'echarts/map/js/province/qinghai'
    import 'echarts/map/js/province/shandong'
    import 'echarts/map/js/province/shanghai'
    import 'echarts/map/js/province/shanxi'
    import 'echarts/map/js/province/shanxi1'
    import 'echarts/map/js/province/sichuan'
    import 'echarts/map/js/province/taiwan'
    import 'echarts/map/js/province/tianjin'
    import 'echarts/map/js/province/xianggang'
    import 'echarts/map/js/province/xinjiang'
    import 'echarts/map/js/province/xizang'
    import 'echarts/map/js/province/yunnan'
    import 'echarts/map/js/province/zhejiang'

    export default {
        name: 'OvopMap',
        props: {
            provinceInfo: {
                type: Array,
                required: true,
                default: []
            },
        },
        components: {
            ECharts
        },
        data() {
            return {
                mapType: 'china',
                options: {
                    geo: {
                        map: 'china'
                    },
                    tooltip:{
                        formatter:(params) => `${params.name} : ${params.value || '--'}`
                    },
                    visualMap: {
                        show: false,
                        min: 0,
                        max: 200,
                        textStyle:{
                            color: '#fff' ,
                        },
                        inRange: {
                            color: [
                                '#EDFFF3',
                                '#D1FFF2',
                                '#C1FFFE',
                                '#9EE6FF',
                                '#7FC0FC',
                            ]
                        }
                    },
                    series: [
                        {
                            type: 'map',
                            map: 'china',
                            label: {
                                show: true,
                                color: '#999',
                                fontSize: 10.5
                            },

                            itemStyle: {
                                areaColor: '#F6F6F6',
                                borderColor: '#ccc',
                                // normal: {
                                //         areaColor: '#F6F6F6',
                                //         borderColor: '#ccc'
                                //     },
//                                     emphasis: {//鼠标移入高亮显颜色
//                                         areaColor: '#f46d43'
//                                     }
                            },
                            data: []
                        }
                    ]
                },
            }
        },
        created() {
//            this.init()
        },
        methods: {
            /**
             * 根据地名全称获取简称
             * @param fullName
             * @returns {*}
             */
            getName(fullName) {
                let result = fullName
                const data = provinceArray.find((e) => e.fullName === fullName)
                if (data) {
                    result = data.name
                }
                return result
            },
        },
        computed: {
            getSelectOptions(){
                return this.$store.state.product.freshOriginInfo.getSelectOptions
            },
            provinceCount(){
                const provinceList = this.provinceInfo  // 选择的省份
                console.log(provinceList)
                const provinceCountList = this.$store.state.product.freshOriginInfo.count || []   // 所有省份的数量
                let newList = []
                provinceCountList.map(item=>{
                    if(provinceList.includes('全部')){
                        newList.push({
                            name:this.getName(item.provinceName),
                            value:item.count
                        })
                    }else {
                        provinceList.map(n=>{
                            if(item.provinceName === n){
                                newList.push({
                                    name:this.getName(item.provinceName),
                                    value:item.count
                                })
                            }
                        })
                    }
                })
                return newList
            }
        },
        watch:{
            provinceCount(val, oldVal){
                this.options.series[0].data = val
            },
        }
    }
</script>

<style lang="scss">
    .echarts {
        width: 720px;
        height: 620px;
    }

    .left {
            display: inline-block;
            width: 720px;
            height: 720px;
            margin-right: 20px;
            vertical-align: top;

            img {
                width: 30px;
                cursor: pointer;
            }

            .city-select {
                width: 230px;
                margin-top: 10px;
            }

            .controls {
                padding: 20px;
                height: 59px;
                border-bottom: 1px solid white;
            }

            .border-bottom {
                border-bottom: 1px solid #f4f4f4;
            }
        }

</style>
